import {UpdateManager} from '@fantasmagames/core/src/update/UpdateManager';
import {Tween} from '@fantasmagames/core/src/tween/Tween';
import {CurrencyFormatter} from '@fantasmagames/core/src/utils/CurrencyFormatter';
import {Easing} from '@fantasmagames/core/src/tween/Easing';
import {IUpdatable} from '@fantasmagames/core/src/update/_interfaces/IUpdatable';

export class Meter extends UpdateManager {
	protected _textObject: PIXI.Text | PIXI.extras.BitmapText;
	protected _tween: Tween;

	protected _valueWrapper: any = {value: 0, targetValue: 0};
	protected _formatter: CurrencyFormatter;

	constructor(textObject: PIXI.Text | PIXI.extras.BitmapText, easing: Function = Easing.Linear.None, formatter?: CurrencyFormatter) {
		super();

		this._textObject = textObject;
		this._formatter = formatter;
		this._tween = new Tween(this._valueWrapper).easing(easing).onUpdate(this.onUpdate.bind(this));
		this.add(this._tween);
		this.onUpdate();
	}

	public remove(updatable: IUpdatable): void {
		super.remove(updatable);
	}

	/**
	 * if the win meter in incrementing this changes it immediately
	 * to the final value.
	 * OnCompleted won't be called
	 */
	public snapToFinalValue(): void {
		this._tween.stop();
		this._valueWrapper.value = this._valueWrapper.targetValue;
		this.onUpdate();
	}

	public set(value: number): Meter {
		this.to(value, 0);
		this.snapToFinalValue();

		return this;
	}

	public from(value: number): Meter {
		this._tween.stop();
		this._valueWrapper.value = value;
		this._valueWrapper.targetValue = value;
		this.onUpdate();

		return this;
	}

	public to(value: number, time: number): Meter {
		this._valueWrapper.targetValue = value;

		if (!this._tween.updateManager) {
			this.add(this._tween);
		}

		this._tween.to({value}, time).start();

		return this;
	}

	public getPredictedValue(time: number): string {
		return this.format(this._tween.getPredictedProperty(time, 'value'));
	}

	protected onUpdate(): void {
		this._textObject.text = this.format(this._valueWrapper.value);
	}

	protected format(value: number): string {
		// return this._formatter ? this._formatter.formatCurrencyFromCents(value) : value.toFixed(2);
		return this._formatter ? this._formatter.formatCurrencyFromCents(value) : value.toFixed(2);
	}

	public get textObject(): PIXI.Text | PIXI.extras.BitmapText {
		return this._textObject;
	}

	public set textObject(value: PIXI.Text | PIXI.extras.BitmapText) {
		this._textObject = value;
	}

	public set onCompleteCallback(value: Function) {
		this._tween.onComplete(value);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/update/Meter.ts